module.exports = __webpack_public_path__ + "img/left.cae34c0f.gif";